/* eslint-disable no-console */
'use strict';
var base = require('./base');
var productGlobalVariable;
var slickClickFlag = false;
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var quantityHelper = require('../quantitySelectorHelper');
var quickViewHelper = require('./quickViewHelper');
var quickViewHelperNew = require('../helpers/quickviewhelper');
var utils = require('../utils');
var quickViewContainerId = '#quickViewModal';

/**
 * One Size product identification
 *
 * @param {string} sizeVariation - to find out product is one size or not
*  @return {boolean} - boolean for one size product identification.
 */
function isOneSizeProduct(sizeVariation) {
    return sizeVariation.id.toLowerCase() === 'one size' || sizeVariation.id.toLowerCase() === 'onesize';
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }

    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog choose-bonus-product-dialog" ' +
        'data-total-qty="' +
        data.maxBonusItems +
        '"' +
        'data-UUID="' +
        data.uuid +
        '"' +
        'data-pliUUID="' +
        data.pliUUID +
        '"' +
        'data-addToCartUrl="' +
        data.addToCartUrl +
        '"' +
        'data-pageStart="0"' +
        'data-pageSize="' +
        data.pageSize +
        '"' +
        'data-moreURL="' +
        data.showProductsUrlRuleBased +
        '"' +
        'data-bonusChoiceRuleBased="' +
        data.bonusChoiceRuleBased +
        '">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <span class="">' +
        data.labels.selectprods +
        '</span>' +
        '    <button type="button" class="close" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();
}

/**
* Load updated product list
* @param {string} pid - product ID
*/
function loadUpdatedProductListByUrl(pid) {
    const $cartListUrl = $('.cart-list-url').val();
    const $targetContainer = $('.shopping-bag__list');
    $.ajax({
        url: $cartListUrl,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            $.spinner().stop();
            $targetContainer.html(data.renderTemplate);
            let cartItemCount = data.numItems > 1 ? '(' + data.numItems + ' items)' : '(' + data.numItems + ' item)';
            $('.order-summary__title .summary-item-count').empty().append(cartItemCount);
            var noQtyError = !data.qtyValid || (data.qtyValid && !data.qtyValid.error);
            $('.cartmerge-error').addClass('d-none');
            if ($('div.ds-cart-error-messaging').length && !data.valid.error && noQtyError) {
                $('.cart-error-messaging').addClass('d-none');
                $('.buttonErrorMessage').addClass('d-none');
            } else if ($('div.ds-cart-error-messaging').length && !noQtyError) {
                $('.cart-qty-error .cart-error_message').empty().append(data.qtyValid.message);
                $('.cart-qty-error').removeClass('d-none');
                $('html, body').animate({ scrollTop: 0 }, 200);
            }

            if (data.items.length) {
                const $cartPage = $('.cart');
                if (data.action.indexOf('Cart') !== -1) {
                    if (!$('.loyalty-info-message .tooltip-wrapper').length) {
                        if (data.antavoRewardPoints && data.antavoRewardPoints.points >= 0) {
                            var html = '<input type="hidden" class="loyalty-info-message-points" value="' + data.antavoRewardPoints.points + '" />';
                            $('.loyalty-info-message .tooltip-wrapper').empty().append(html);
                            $('.order-summary-container .loyalty-rewards-box-model-cart .points-display, .device-summary-msg .loyalty-rewards-box-model-cart .points-display').html(data.antavoRewardPoints.points);
                            $('.order-summary-container, .device-loyalty-pointscontainer').removeClass('hide-antavo-copy');
                            if (data.antavoRewardPoints.points === 0) {
                                $('.order-summary-container, .device-loyalty-pointscontainer').addClass('hide-antavo-copy');
                            }
                        }
                    }
                    $cartPage.addClass('has-cart-items, cart-page');
                    $('.shipping--intro').removeClass('d-none');
                    $cartPage.removeClass('cart-empty');
                    var event = 'cart_add';
                    tealiumEnable.getAnalyticsData('moveToBagEvent', pid, data, event);
                }
            } else {
                const $cartPage = $('.cart');
                $cartPage.removeClass('has-cart-items, cart-page');
                $('.shipping--intro').addClass('d-none');
                $cartPage.addClass('cart-empty');
            }
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the 'Add to Cart' button
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {string} pid - product ID
 */
function handlePostCartAdd(response, pid) {
    if (!$('#quickViewModal.show .quickview-set').length) {
        // Skip modal close for Product set pages
        $('#quickViewModal .modal-close button.close').trigger('click');
    }
    const $cartListUrl = $('.cart-list-url');
    // do not load product load if this is not in cart page
    if ($cartListUrl.length) {
        $('html, body').animate({ scrollTop: 0 }, 200);
        utils.showConfirmToast(response.message);
        // update shopping bag item from cart
        loadUpdatedProductListByUrl(pid);
    }
    $('.minicart').trigger('count:update', response);
    $('body').trigger('product:afterAddToCart', response);
    utils.updateCartCount(response.quantityTotal);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (
        response.newBonusDiscountLineItem &&
        Object.keys(response.newBonusDiscountLineItem).length !== 0
    ) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append('<div class="add-to-cart-messages"></div>');
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' +
            messageType +
            ' add-to-basket-alert text-center" role="alert">' +
            response.message +
            '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

/**
 * @param {Object} attr attribute list
 * @param {boolean} strikeThroughStatus return strike through status value
 * @param {string} qvContainerID - quick view container ID
 */
function processNonSwatchValues(attr, strikeThroughStatus, qvContainerID) {
    attr.values.forEach(function (attrValue, index) {
        var $attrValue = $(qvContainerID + ' #' + attr.id + 'item' + index);
        const attributeId = attr.id + 'item' + index;
        var isSelectableLabel = $(`${qvContainerID} #${attributeId}`);
        // $attrValue.attr('data-url', attrValue.url).removeAttr('disabled');
        $attrValue.attr('data-url', attrValue.url).removeClass('disabled oos-variant');
        $attrValue.attr('tabindex', '0');
        if (!attrValue.selectable) {
            // $attrValue.attr('disabled', '');
            $attrValue.addClass('disabled oos-variant');
            $attrValue.attr('tabindex', '-1');
            if (!strikeThroughStatus) {
                $(isSelectableLabel).css('display', 'none');
            }
        } else {
            $(isSelectableLabel).css('display', 'flex');
        }
        if (attrValue.selected) {
            $(qvContainerID + ' h3.' + attr.id).html(
                '<span class="variation__attr--name">' + attr.displayName + '</span><span class="variation__attr--value">' + attr.displayValue + '</span>'
            );
            $attrValue.attr('aria-checked', 'true');
        } else {
            $attrValue.attr('aria-checked', 'false');
        }
    });
}
/**
 * @param {string} attrs selects color
 * @param {boolean} strikeThroughStatus return strike through status value
 * @param {string} qvContainerID defines the boundary around quickview modal
 */
function updateAttrs(attrs, strikeThroughStatus, qvContainerID) {
    var isOneSize = isOneSizeProduct(attrs[1].values[0]);
    attrs.forEach(function (attr) {
        if (attr.swatchable) {
            quickViewHelper.processSwatchValues(attr, strikeThroughStatus, qvContainerID);
        } else {
            processNonSwatchValues(attr, strikeThroughStatus, qvContainerID);
        }
        if (isOneSize) {
            if (!attr.swatchable && attr.displayValue === '') {
                $(qvContainerID + ' h3.' + attr.id).html(
                    '<span class="variation__attr--name">' + attr.displayName + '</span><span class="variation__attr--value">' + attr.values[0].displayValue + '</span>'
                );
            }
        } else if (!attr.swatchable && attr.displayValue === '') {
            $(`${qvContainerID} h3.${attr.attributeId}`).html(`<span class="variation__attr--name">${attr.displayName}</span>`);
        }
    });
}

/**
 * @param {string} message - error message
 */
function handleDataError(message) {
    var $pageQuantityError = $(quickViewContainerId + ' .page-quantity-error');
    $pageQuantityError.html(utils.showErrorMessage(message));
    $pageQuantityError[0].scrollIntoView({ behavior: 'smooth' });
}

/**
 * @param {Object} product - response object
 * @param {string} qvContainerID - quick view container ID
 */
function updateImages(product, qvContainerID) {
    var imgResponse = '';
    var imgObj = {};
    if (product.imageDimentions.desktop.product) {
        imgObj.desktop = product.imageDimentions.desktop.product;
        imgObj.mobile = product.imageDimentions.mobile.product;
    } else {
        imgObj.desktop = product.imageDimentions.desktop.quickBuy.product;
        imgObj.mobile = product.imageDimentions.desktop.quickBuy.product;
    }
    product.images.large.forEach((item, index) => {
        imgResponse += '<div class="' + (index === 0 ? 'active' : '') + '">' +
            utils.renderPictureTag(item, { devices: { desktop: imgObj.desktop, mobile: imgObj.mobile }, className: 'quickview-slick-img' }) +
            '</div>';
    });
    if ($(qvContainerID + ' .js-quickview-slick').hasClass('slick-initialized')) {
        $(qvContainerID + ' .js-quickview-slick').slick('removeSlide', null, null, true);
    } else {
        $(qvContainerID + ' .js-quickview-slick').html('');
    }
    $(qvContainerID + ' .js-quickview-slick').slick('slickAdd', imgResponse);
    // update slide count
    if ($('.js-quickview-slick').slick('getSlick') && $('.js-quickview-slick').slick('getSlick').slideCount !== undefined && $('.js-quickview-slick').slick('getSlick').slideCount !== null) {
        $('.slide-count').text('1 / ' + $('.js-quickview-slick').slick('getSlick').slideCount); // Initialize slide count
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {string} qvContainerID - quick view container ID
 */
function handleVariantResponse(response, qvContainerID) {
    if (response.product.variationAttributes) {
        updateAttrs(
            response.product.variationAttributes,
            response.product.strikeThroughStatus,
            qvContainerID
        );
    }
    var productUrl = response.product.pdpurl ? response.product.pdpurl : response.product.selectedProductUrl;
    $(qvContainerID + ' .quickview__modal__head--name').html(
        '<a class="quickview__modal-heading-link" href=' + productUrl + '>' + response.product.productName + '</a>'
    );
    // Update Promotions
    $(qvContainerID + ' .quickview__modal__body--inner').find('.product-promotions').empty().html(response.product.promotionsHtml);
    updateImages(response.product, qvContainerID);
    quickViewHelper.updateProductURL(response.product, $('#quickViewModal'));
    $(qvContainerID + ' .quickview__modal__body--prices').empty().html(response.product.price.html);
    $(
        qvContainerID + ' button.add-to-cart,' + qvContainerID + ' button.add-to-cart-global,' + qvContainerID + ' button.update-cart-product-global'
    )
        .trigger('product:updateAddToCartQuickView', {
            product: response.product
        })
        .trigger('product:statusUpdate', response.product);

    // Update antavo points
    if (response.product.antavoPoints) {
        $(qvContainerID).find('.antavo-points').empty().html(response.product.antavoPoints);
    }

    // Update antavo multiplier
    $(qvContainerID).find('.wrapper-antavo-multiflier').empty();
    if (response.product.antavoPointsMultiplier > 1) {
        let $multiplierHtml = `<span class="antavo-multiflier">${response.product.antavoPointsMultiplier}X</span>`;
        $(qvContainerID).find('.wrapper-antavo-multiflier').append($multiplierHtml);
    }
    // Hide 'UPTO' text when a size is selected
    if (response.product.price.type === 'range') {
        $(qvContainerID).find('.text-more span').show();
    } else {
        $(qvContainerID).find('.text-more span').hide();
    }
}

// /**
//  * Update Badges
//  * @param {Object} responseData - Data response from AJAX call
//  * @param {string} qvContainerID - quick view container ID
//  */
// function updateBadges(responseData, qvContainerID) {
//     var isOneSize = isOneSizeProduct(responseData.variationAttributes[1].values[0]);
//     var availabilityValue = '';
//     var preOrderStatus = '';
//     var availabilityMessages = responseData.availability.messages;
//     var isAvailability = responseData.available;
//     var imgbadges = '';
//     var stockBadges = '';
//     var saleBadges = '';
//     var responseMessage = responseData.badgeSkuLevelStatus.preOrderMessage;
//     var responseMessageDate = responseData.badgeSkuLevelStatus.preOrderMessageDate;
//     if (responseData.badgeSkuLevelStatus.preOrderStatus) {
//         preOrderStatus += '<div class="pre-order"> <span>' + responseMessage + '</span> <span class="pre-order-date">' + responseMessageDate + '</span> </div>';
//     }
//     availabilityMessages.forEach(function (message) {
//         if (responseData.badgeSkuLevelStatus.availabilityStatus) {
//             if (isAvailability) {
//                 availabilityValue += `<li><div class="${isAvailability ? '' : 'custom-error'}">${message}</div></li>`;
//             }
//         }
//     });

//     if (responseData.badgeSkuLevelStatus.newBadge) {
//         imgbadges += responseData.badgeSkuLevelStatus.newBadge;
//         imgbadges += responseData.badgeSkuLevelStatus.imageBadge1 || responseData.badgeSkuLevelStatus.imageBadge2 ? ' , ' : '';
//     }

// imgbadges = utils.quickViewBadges(responseData);

//     if (responseData.badgeSkuLevelStatus.finalSalestatus) {
//         saleBadges += '<div class="custom-error product-detail__salebadges-text quickview__modal__body--finalBadge">Final Sale</div>';
//     }
//     if (responseData.readyToOrder || isOneSize) {
//         $(qvContainerID + ' .availability-msg').removeClass('error').empty().html(availabilityValue);
//     } else {
//         $(qvContainerID + ' .availability-msg').removeClass('error').empty().html('');
//     }
//     $(qvContainerID + ' .preorder-status').empty().html(preOrderStatus);
//     $(qvContainerID + ' .product-detail__imgbadges').empty().html(imgbadges);
//     $(qvContainerID + ' .product-detail__stockBadges').empty().html(stockBadges);
//     $(qvContainerID + ' .product-detail__salebadges').empty().html(saleBadges);
// }

/**
 *
function to handle previous error response from server
 * @param {string} attribute_id - Attribute ID
 * @param {string} qvContainerID - quick view container ID
 */
function handlePreviousErrorResponse(attribute_id, qvContainerID) {
    // Safe selectors by avoiding dynamic selector concatenation
    var quickViewContainer = $(qvContainerID);
    quickViewContainer.find('.' + attribute_id + ' span.variation__attr--name').removeClass('modal-error-color');
    quickViewContainer.find('li[role="radio"].variant-' + attribute_id + ' span').removeClass('modal-error-color');
    quickViewContainer.find('#pdpAttribute div.variant-selector-container .variant-item').removeClass('modal-error-border');
    quickViewContainer.find('.variant-error-' + attribute_id).removeClass('show').addClass('hide');
    if (attribute_id === 'colorCode') {
        quickViewContainer.find('.variant-error').removeClass('show').addClass('hide');
    }
}

/**
 * @param {string} selectedValueUrl selects size
 * @param {jQuery} productContainer - DOM element for current product
 * @param {string} eventName event name on variation select
 * @param {string} attrId - attribute ID of product
 * @param {string} qvContainerID - quick view container ID
 */
function attributeSelect(selectedValueUrl, productContainer, eventName, attrId, qvContainerID) {
    // $productContainer
    if (selectedValueUrl) {
        var $quickviewModalContent = $('.quickview__modal--content');
        var $defaultImage = $(qvContainerID + ' .primary-images > #defaultImage');
        $quickviewModalContent.addClass('qv-lock');
        if ($defaultImage) $defaultImage.hide();
        $.ajax({
            url: selectedValueUrl + '&showQuickView=true',
            method: 'GET',
            success: function (data) {
                var isOneSize = isOneSizeProduct(data.product.variationAttributes[1].values[0]);
                var quickViewModalPos = $quickviewModalContent.scrollTop();
                var addToBagButtonText = $(qvContainerID + ' .add-to-cart-hidden').val();
                var productData = data.product;
                var productId = productContainer.data('pid');
                var buttonHtmlSelectSize = $(qvContainerID + ' .select-size-hidden').val();
                var oosButton = 'Out of Stock';
                productGlobalVariable = data.product;
                var buttonSalesPrice = data.product.isAddToBagPrice && data.product.price.salesDisplayPrice ? ' - ' + data.product.price.salesDisplayPrice : '';
                var isAvailability = data.product.available;
                var isAuthenticated = $('.isauthenticated').data('isauthenticated');
                if (data.product.isMembersOnly && !isAuthenticated) {
                    $('.login-acc-container.member-signin-link').removeClass('d-none');
                    $('button.add-to-cart-global').addClass('d-none');
                } else if (data.product.isMembersOnly && isAuthenticated) {
                    $('.login-acc-container.member-signin-link').addClass('d-none');
                    $('button.add-to-cart-global').removeClass('d-none');
                } else {
                    $('.login-acc-container.member-signin-link').addClass('d-none');
                    $('button.add-to-cart-global').removeClass('d-none');
                }
                if (buttonSalesPrice === '') {
                    buttonSalesPrice = data.product.isAddToBagPrice && data.product.price.showSavings ? ' - ' + data.product.price.salesDisplayRange : '';
                }
                var buttonAddToCartGlobal = $('button.add-to-cart-global');
                var cartActionsContainer = $('.quickview__modal__footer .cart-and-ipay');
                $('.page-quantity-error').empty();
                handleVariantResponse(data, qvContainerID);
                quickViewHelperNew.default.updateBadges(data.product, qvContainerID);
                quantityHelper.updateQuantities(data.product, productContainer, productId, qvContainerID);
                handlePreviousErrorResponse(attrId, qvContainerID);
                var colorCodes = $(qvContainerID + ' .variant-colorCode');
                var isSizeSelected;
                var variantItemAria = $(qvContainerID + ' .variant-item[aria-checked="true"]');
                isSizeSelected = variantItemAria.length === data.product.variationAttributes.length - 1
                    ? variantItemAria.hasClass('disabled')
                    : false;
                utils.oosColorSwatches(data.product.variationAttributes, colorCodes);
                $('.error-text').remove();
                if (isOneSize && data.product.oneSizeSKUID) {
                    $(qvContainerID + ' .add-to-cart-global').attr('data-cur-pid', data.product.oneSizeSKUID);
                } else {
                    $(qvContainerID + ' .add-to-cart-global').attr('data-cur-pid', data.product.id);
                }
                $('.modal.show .full-pdp-link').attr('href', data.product.selectedProductUrl);
                if (!data.product.readyToOrder && !isOneSize) {
                    if (data.product.orderable) {
                        if (isSizeSelected && data.product.available) {
                            buttonAddToCartGlobal.html(oosButton).prop('disabled', true);
                            cartActionsContainer.addClass('qv-footer-oos');
                        } else {
                            buttonAddToCartGlobal.text(buttonHtmlSelectSize);
                            cartActionsContainer.removeClass('qv-footer-oos');
                        }
                    } else if (isSizeSelected && !data.product.available) {
                        buttonAddToCartGlobal.empty().html(oosButton).prop('disabled', true);
                        cartActionsContainer.addClass('qv-footer-oos');
                    } else if ($('.variant-item[aria-checked="true"]').length !== data.product.variationAttributes.length - 1) {
                        buttonAddToCartGlobal.empty().html(buttonHtmlSelectSize);
                        cartActionsContainer.removeClass('qv-footer-oos');
                    } else {
                        buttonAddToCartGlobal.empty().html(buttonHtmlQbbM);
                        cartActionsContainer.removeClass('qv-footer-oos');
                    }
                } else if (productData.badgeSkuLevelStatus.preOrderStatus) {
                    buttonAddToCartGlobal.empty().text(productData.badgeSkuLevelStatus.preOrderBadge + buttonSalesPrice);
                    cartActionsContainer.removeClass('qv-footer-oos');
                } else if (!isAvailability) {
                    buttonAddToCartGlobal.empty().html(oosButton).prop('disabled', true);
                    cartActionsContainer.addClass('qv-footer-oos');
                } else {
                    // $('button.add-to-cart-global').empty().html(buttonHtmlSelectSize);
                    buttonAddToCartGlobal.removeAttr('disabled');
                    buttonAddToCartGlobal.empty().text(addToBagButtonText + buttonSalesPrice);
                    cartActionsContainer.removeClass('qv-footer-oos');
                }
                // check for available inventory and update button state
                if ((data.product.maxQuantityAllowed < data.product.selectedQuantity) && ($('#select-variantQty-' + data.product.maxQuantityAllowed)).attr('selected')) {
                    buttonAddToCartGlobal.removeAttr('disabled').empty().text(addToBagButtonText + buttonSalesPrice);
                    cartActionsContainer.removeClass('qv-footer-oos');
                }

                var $primaryImages = $(qvContainerID + ' .primary-images');
                if ($primaryImages) {
                    if ($primaryImages.outerHeight() === 0) {
                        $(qvContainerID + ' .primary-images > #defaultImage').show();
                    } else {
                        $(qvContainerID + ' .primary-images > #defaultImage').hide();
                    }
                }
                $quickviewModalContent.scrollTop(quickViewModalPos);
                $quickviewModalContent.removeClass('qv-lock');
                if ($('.product-set-detail').length) {
                    $('body').trigger('productSet:quickview');
                }
                // null check to disable/enable addToBag CTA
                var eventNameCopy = eventName;
                utils.disableButton($(qvContainerID + ' button.add-to-cart-global'), data.product.price.salesDisplayPrice);
                // Re-apply disabled if button is showing OOS text
                if ($(qvContainerID + ' button.add-to-cart-global').text().trim() === oosButton) {
                    $(qvContainerID + ' button.add-to-cart-global').prop('disabled', true);
                }
                data.product.variationAttributes.forEach(variationAttribute => {
                    var selectedAttrValue = variationAttribute.displayValue;
                    variationAttribute.values.forEach(value => {
                        if (selectedAttrValue === value.displayValue && !value.selectable) {
                            eventNameCopy += ',product_upc_color_size_combo_sold_out';
                        }
                    });
                });

                if (eventNameCopy !== '') {
                    tealiumEnable.getAnalyticsData('getVariationSelectedData', productData, eventName, 'pdp');
                }
            },
            error: function () {
                $quickviewModalContent.spinner().stop();
            }
        });
    }
}

/**
 * Handles the errors for the variation categories
 * @param {string} productID - product id
 */
function handleVariantErrorMessage(productID) {
    var $variantError;
    var variationErrorAnalytics = [];
    $('#quickViewModal .variant-list, #editProductModal .variant-list, #editProductModalMob .quickbuy--variant-list').each(function () {
        var $this = $(this);
        if ($this.hasClass('colors-variant-list')) {
            return;
        }
        var mode_of_variant = $this.data('display-id');
        var variantValue = $this.data('display-value');
        if ($this.has('.variant-item[aria-checked="true"], .variant-color-item[aria-checked="true"]').length) {
            $('li[role="radio"].variant-' + mode_of_variant).removeClass('modal-error-border');
            $this.closest('#pdpAttribute').find('.variant-error').removeClass('show');
            $this.closest('#pdpAttribute').find('.variant-error').addClass('hide');
        } else {
            $variantError = $this.closest('#pdpAttribute').find('.variant-error');
            $variantError.removeClass('hide').addClass('show');
            $('#quickViewModal, #editProductModal, #editProductModalMobfind').find('.' + mode_of_variant + ' span.variation__attr--name').addClass('modal-error-color');
            $('li[role="radio"].variant-' + mode_of_variant).addClass('modal-error-border');
            variationErrorAnalytics.push('Please Select a ' + variantValue);
        }
    });

    if ($variantError && $variantError.length > 0) {
        var isProductSet = !!$('body').has('div.product-set-detail').length;
        var scrollOptions = { behavior: 'smooth', block: 'nearest' };

        // set scroll pos to default in product set quick view
        if (isProductSet) {
            scrollOptions.block = 'start';
        }

        $variantError[0].scrollIntoView(scrollOptions);
        var productName = $(quickViewContainerId + ' .quickview__modal__head--name a').html();
        var eventName = 'product_variant_error';
        var productColorName = $(quickViewContainerId + ' [data-attr="colorCode"] .variation__attr--value').html();
        var productColorCode = $(quickViewContainerId + ' [data-attr="colorCode"] .variant-list[data-display-id="colorCode"] li[aria-checked="true"]').attr('data-attr-value');
        var variationErrorAnalyticsValue = variationErrorAnalytics.join(',');
        var productColorNameArray = [];
        var productColorCodeArray = [];
        var productNameArray = [];
        var productIDArray = [];
        productColorNameArray.push(productColorName);
        productColorCodeArray.push(productColorCode);
        productNameArray.push(productName);
        productIDArray.push(productID);
        var variationErrorData = [];
        variationErrorData.push(variationErrorAnalyticsValue);
        var addToCartErrorData = {
            event_name: eventName,
            product_style_id: productIDArray,
            product_name: productNameArray,
            product_upc_color_code: productColorCodeArray,
            product_upc_color_name: productColorNameArray,
            variant_error: variationErrorData
        };
        tealiumEnable.getAnalyticsData('quickViewAddToCartErrorEvent', productID, addToCartErrorData);
    }
}

/**
 * function to handle validation UI on Quantity Selector
 * @param {string} mode_of_variant - when user clicks on the add to bag button without selecting size then gives the value as size in string
 * @param {string} mode_of_variant_value - value of mode_of_variant
 * @param {string} qvContainerID - ID of the quick view container
 */
function updateVariantOnQuantitySelectorStatus(mode_of_variant, mode_of_variant_value, qvContainerID) {
    if ($(qvContainerID + ' .' + mode_of_variant + ' span.variation__attr--name').html()) {
        const isVariantLabelAvailable = $(qvContainerID + ' .' + mode_of_variant + ' span.variation__attr--name').html().replace(/\s+/g, ' ').trim();
        if (isVariantLabelAvailable.toLowerCase() === 'select ' + mode_of_variant_value.toLowerCase() + '') {
            $(qvContainerID + ' .' + mode_of_variant + ' span.variation__attr--name').addClass('modal-error-color');
            $($(qvContainerID + ' .' + mode_of_variant).parents('#pdpAttribute')).find('div.variant-selector-container .variant-item').addClass('modal-error-border');
            $(qvContainerID + ' li[role="radio"].variant-' + mode_of_variant + ' span').addClass('modal-error-border');
            $(qvContainerID + ' .variant-error-' + mode_of_variant).removeClass('hide');
            $(qvContainerID + ' .variant-error-' + mode_of_variant).addClass('show').trigger('focus');
        }
    }
}

/**
 * Delete session storage item openQVSigntoBuy
 */
function removeSessionopenQVSigntoBuyn() {
    $(window).on('load', function () {
        sessionStorage.removeItem('openQVSigntoBuy');
    });
}


module.exports = {
    ...base,
    quickViewContainerId,
    showQuickview: function () {
        $(document).on('keyup', '.product-recommendation__tile-wrapper .ds-product-tile', function (e) {
            if (e.code === 'Enter') {
                $(this).find('.quickview').trigger('click');
            }
        });
    },

    addToCart: function () {
        $(document).on(
            'click',
            `${quickViewContainerId} button.add-to-cart, ${quickViewContainerId} button.add-to-cart-global`,
            function () {
                var recommendationType = $('body').has('div[data-recomtype]').length ? $('body div[data-recomtype]').data('recomtype') : '';
                var isProductSet = !!$('body').has('div.product-set-detail').length;
                var pid = $(this).attr('data-cur-pid');
                if (pid === undefined) {
                    pid = $(this).attr('data-pid');
                }
                var qty = $(quickViewContainerId + ' .quantity-dropdown option:selected').val();
                var addToCartUrl = $(quickViewContainerId + ' .add-to-cart-url').val();
                var readyToOrder = $(quickViewContainerId + ' .add-to-cart-global').attr('data-readytoorder');
                var pageType = $('.page.current').data('page');
                $('.error-text').remove();
                var csrf_token = $('.csrf-token').attr('data-csrf-value');
                var form = {
                    pid: pid,
                    quantity: qty,
                    pageType: pageType,
                    csrf_token: csrf_token
                };
                handleVariantErrorMessage(pid.split('-')[0]);
                if (addToCartUrl && readyToOrder === 'true') {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: form,
                        success: function (data) {
                            if (data.error) {
                                handleDataError(data.message);
                            } else {
                                $('.page-quantity-error').empty();
                                handlePostCartAdd(data, pid);
                                $('body').trigger('product:afterAddToCart', data);
                                productGlobalVariable = data.cart.items.find(item => item.id === form.pid);
                                tealiumEnable.getAnalyticsData('getAddToCartData', productGlobalVariable, data.cart.basketUUID, '', isProductSet ? 'bundle' : recommendationType, pageType);
                                $.spinner().stop();
                            }
                        },
                        error: function (data) {
                            let message = data.responseJSON.message;
                            let errorHandling = function () {
                                $.spinner().stop();
                                $('.error-text').remove();
                                $('.quickview__modal__footer').prepend(`<span class="error-text page-error d-none"><svg class="icon-utility-alert-red"><use xlink:href="#alert-red"></use></svg>${message}</span>`);
                                $('#quickViewModal .error-text').removeClass('d-none').trigger('focus');
                                tealiumEnable.getAnalyticsData('serverError', data.responseJSON.errorCode);
                            };
                            if (data.responseJSON.csrfError) {
                                var authenticatedCustomer = data.responseJSON.authenticatedCustomer;
                                $('.isauthenticated').data('isauthenticated', authenticatedCustomer);
                                if ($('.ismembersonly').data('ismembersonly') && !authenticatedCustomer) {
                                    $('.login-acc-container.member-signin-link').removeClass('d-none');
                                    $('button.add-to-cart-global').addClass('d-none');
                                } else if ($('.ismembersonly').data('ismembersonly') && authenticatedCustomer) {
                                    $('.login-acc-container.member-signin-link').addClass('d-none');
                                    $('button.add-to-cart-global').removeClass('d-none');
                                } else {
                                    $('.login-acc-container.member-signin-link').addClass('d-none');
                                    $('button.add-to-cart-global').removeClass('d-none');
                                }
                                utils.handleCsrfToken(errorHandling);
                            } else {
                                errorHandling();
                            }
                        }
                    });
                }
            }
        );
    },

    colorAttribute: function () {
        $(document).on(
            'click',
            `${quickViewContainerId} .variant-color-item:not([disabled])`, function (e) {
                e.preventDefault();
                var $productContainer = $(quickViewContainerId + ' .product-detail');
                var selectedValueUrl = $(this).attr('data-url');
                var eventName = 'product_change_color';
                var selectedAttrId = $(this).attr('data-display-id');

                // send color only url to reset size selection for multi-demension products and non-available sizes
                if ($(this).hasClass('oss-color')) {
                    if ($('.attribute-item.swatch').length > 2 || $('.quickview__modal__body--attribute').hasClass('strike-through-false')) {
                        selectedValueUrl = $(this).data('url-color');
                    }
                }
                attributeSelect(selectedValueUrl, $productContainer, eventName, selectedAttrId, quickViewContainerId);
            }
        );

        $(document).on('keyup', `${quickViewContainerId} .variant-color-item:not([disabled])`, function (event) {
            if (event.code === 'Enter') {
                $(this).trigger('click');
            }
        });
    },

    selectAttribute: function () {
        $(document).on('click', `${quickViewContainerId} .variant-item:not([disabled])`, function (e) {
            e.preventDefault();
            var $productContainer = $(quickViewContainerId + ' .product-detail');
            var selectedValueUrl = $(this).attr('data-url');
            var eventName = 'product_change_size';
            var selectedAttrId = $(this).attr('data-display-id');
            attributeSelect(selectedValueUrl, $productContainer, eventName, selectedAttrId, quickViewContainerId);
        });

        $(document).on('keyup', `${quickViewContainerId} .variant-item:not([disabled])`, function (event) {
            if (event.code === 'Enter') {
                $(this).trigger('click');
            }
        });
    },

    quantitySelect: function () {
        $(document).on('change', `${quickViewContainerId} .quantity-dropdown select`, function (e) {
            e.preventDefault();
            var $productContainer = $(quickViewContainerId + ' .product-detail');
            var selectedValueUrl = $('option:selected', $(this)).data('url');
            if (quantityHelper.isProductSetavailable()) {
                $productContainer = $(this).closest('.set-item.productSet-wrapper');
            }
            var eventName = '';
            attributeSelect(selectedValueUrl, $productContainer, eventName, '-', quickViewContainerId);
        });
    },

    updateAddToCart: function () {
        $('body').on('product:updateAddToCartQuickView', function (e, response) {
            // update local add to cart (for sets)
            e.preventDefault();
            e.stopPropagation();
            var isOneSize = isOneSizeProduct(response.product.variationAttributes[1].values[0]);
            $(quickViewContainerId + ' .add-to-cart-global').attr('data-readytoorder', (response.product.readyToOrder || isOneSize));
        });
    },

    quickViewSlickAnalytics: function () {
        $(document).on('click', '.js-quickview-slick .slick-arrow', function () {
            if (!slickClickFlag) {
                var eventName = 'product_image_interaction';
                tealiumEnable.getAnalyticsData('getVariationSelectedData', productGlobalVariable, eventName, 'pdp');
                slickClickFlag = true;
            }
        });
        $(document).on('hidden.bs.modal', '#quickViewModal', function () {
            slickClickFlag = false;
        });
    },

    quickViewQuantityErrorWarning: function () {
        $(document).on('click', `${quickViewContainerId} .js-quantitySelector`, function (e) {
            let containerData = e.target.nodeName !== 'SELECT' ? $(e.target).siblings('select') : e.target;
            if ($(containerData).attr('disabled')) {
                const variants = $('#quickViewModal').find('.variant-list:not([data-display-id="colorCode"])').toArray();
                variants.forEach(elem => {
                    const variant = $(elem)[0].dataset.displayId;
                    const variantValue = $(elem)[0].dataset.displayValue;
                    let variantItem = $(quickViewContainerId + ' section.attributes').find('label.' + variant);
                    if (variantItem.length) {
                        updateVariantOnQuantitySelectorStatus(variant, variantValue, quickViewContainerId);
                    }
                });
            }
        });
    },
    removeSessionopenQVSigntoBuyn,
    handleVariantErrorMessage
};
